enum RewardType {
  Unknown = 0,
  Percent,
  Fixed,
  Wallet,
  WalletAndPayment,
  Payment,
  FreeItem,
  PaymentPlusReward,
  Redeemable,
  MealExchange,
  WalletAndPaymentTaxExempt,
}

export { RewardType };
